import {Component, OnInit} from '@angular/core';
import {GlobalSearchService} from "@core/globalSearch/globalSearch.service";
import {Location} from "@angular/common";
import {ActivatedRoute, NavigationExtras, Router} from "@angular/router";
import {KngActivityIndicatorService} from "@layout/kingswell/services/kngActivityIndicator.service";

enum SEARCH_STATUS {
  START = "start",
  IN_PROGRESS = "inprogress",
  DONE = 'done'
}

@Component({
  selector: 'search-page',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.less']
})

export class SearchPageComponent implements OnInit {
  searchText: string;
  public results: any[] = [];
  public resultsCount: number = undefined;
  public searchStatus: SEARCH_STATUS = SEARCH_STATUS.START;

  constructor(private _location: Location, private route: ActivatedRoute, private router: Router,
              private kngActivityIndicator: KngActivityIndicatorService,
              private globalSearchService: GlobalSearchService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      // When search Parameter changes, do search
      this.search(params.searchText);
    });
  }

  search(text) {
    console.log('searching');
    this.searchText = text;

    this.results = [];
    this.resultsCount = undefined;
    if (text && text.length > 2) {
      this.kngActivityIndicator.show();
      this.searchStatus = SEARCH_STATUS.IN_PROGRESS;
      this.globalSearchService.search(text, 25)
        .then(results => {
          this.results = results.results;
          this.resultsCount = results.count;
          this.searchStatus = SEARCH_STATUS.DONE;
          this.kngActivityIndicator.close();
        });
    } else {
      this.searchStatus = SEARCH_STATUS.START;
      this.kngActivityIndicator.close();
    }
  }

  onSearchTextChange(text) {
    let navExtra: NavigationExtras = {
      queryParamsHandling: "merge",
      queryParams: {searchText: text}
    };
    this.router.navigate(['search'], navExtra);
  }

  close() {
    this._location.back();
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/pages/search/search.component.ts